import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DASHBOARD, PROJECT, IMAGECOUNT, TIMELAPSEALL, LIVECAMALL, WORKSITEALL } from "../../services/actions";
import {
  Typography,
  Container,
  Grid,
  Box,
} from "@mui/material";
import StatusCard from "./StatusCard";
import CameraCard from "./CameraCard";
import InfoListCard from "./InfoListCard";
import ProjectsChart from "./Analytics";
import WeatherCard from "../extra/WeatherCard";
import VectorMap from "../extra/VectorMap";
import './dashboard.css'

function getDays(_d, duration = 30) {
  const createdAt = new Date(_d);
  const now = new Date();

  const diffTime = now - createdAt; // milliseconds
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  //console.log(`${diffDays} days have passed`);
  //console.log(`${Math.max(0, duration - diffDays)} days left (if 30-day period)`);
  return diffDays
  //return Math.max(0, 30 - diffDays)
}

export default function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loc, setLoc] = useState([]);

  const {
    dashboardState,
    imagecountState,
    projectState,

    loginState: { auth: user },
  } = useSelector((state) => state);
  const timelapseallState = useSelector((state) => state?.timelapseallState);
  const livecamallState = useSelector((state) => state?.livecamallState);
  let worksiteallState = useSelector((state) => state?.worksiteallState);
  // const [weatherData, setWeather] = React.useState({})
  const [cameras, setCameras] = React.useState([])

  const [locationName, setLocationName] = useState("West bay, Doha");


  // Add the handler for the Location Card
  // const handleLocationClick = () => {
  //   // 1. Define the target path (must match your route definition for MapView)
  //   const targetPath = '/map-view'; // **Use your actual route path here**

  //   // 2. Use the navigate function to go to the path AND pass the state
  //   navigate(targetPath, {
  //     state: {
  //       // This 'markers' key must match what MapView is looking for
  //       markers: loc,
  //     },
  //   });
  // };


  useEffect(() => {
    dispatch({ type: `${DASHBOARD}_GET`, payload: 0 });
    dispatch({ type: `${PROJECT}_GET`, payload: 0 });
    dispatch({ type: `${IMAGECOUNT}_GET`, payload: 0 });
    dispatch({ type: `${TIMELAPSEALL}_GET`, payload: 0 });
    // dispatch({ type: `${LIVECAMALL}_GET`, payload: 0 });
    // setCameras(timelapseallState?.data?.results || [])

  }, [dispatch]);

  useEffect(() => {
    setCameras(timelapseallState?.data?.results || [])
  }, [timelapseallState?.data?.results])

  useEffect(() => {
    setCameras(livecamallState?.data?.results || [])
  }, [livecamallState?.data?.results])

  useEffect(() => {
    let lo = getLocations(imagecountState?.data?.results || [], "camera_location")
    setLoc(lo)
  }, [imagecountState?.data])

  useEffect(() => {
    const dataLength = imagecountState?.data?.results?.length || 0;

    if (dataLength === 0) return;

    // if (intervalRef.current) clearInterval(intervalRef.current);

    // intervalRef.current = setInterval(() => {
    //   indexRef.current = (indexRef.current + 1) % dataLength;
    //   setAnalysis(indexRef.current);
    // }, 3000);

    // return () => {
    //   if (intervalRef.current) clearInterval(intervalRef.current);
    // };
  }, [imagecountState?.data?.results?.length]);

  useEffect(() => {
    let location = dashboardState?.data?.location;

    if (location) {
      try {
        let locObj = {
          country_name: location?.split("$")[0],
          lat: location?.split("$")[1].split(",")[0],
          lon: location?.split("$")[1].split(",")[1]
        };
        setLocationName(locObj);
      } catch (e) {
        return;
      }
    } else {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const lat = position.coords.latitude;
            const lon = position.coords.longitude;
            try {
              const response = await fetch(
                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
              );
              const data = await response.json();
              const country_name = data.address?.country || "Current Location";

              setLocationName({
                country_name: country_name,
                lat: lat.toString(),
                lon: lon.toString()
              });
            } catch (error) {
              console.error("Error fetching country name:", error);
              setLocationName({
                country_name: "Current Location",
                lat: lat.toString(),
                lon: lon.toString()
              });
            }
          },
          (error) => {
            console.error("Geolocation error:", error);
          }
        );
      }
    }
  }, [dashboardState?.data]);

  const getLocations = (datas, key, nameKey) => {
    // Helper: clean the camera_location string and split into [lat, lng]
    function rel(d, key) {
      const parts = d[key]?.replace(/[^\d.,-]/g, '')?.split(',');
      return parts?.map(Number); // Convert strings to numbers
    }
    // Create objects like { latlng: [lat, lng], desc: 'camera name' }
    let ds = datas.map((d) => ({

      latlng: rel(d, key),
      desc: d[nameKey],
      thumbnail: d.thumbnail
    }));
    // Filter: only keep those with valid lat/lng numbers
    return ds.filter(
      (d) =>
        d.latlng &&
        d.latlng.length === 2 &&
        !isNaN(d.latlng[0]) &&
        !isNaN(d.latlng[1])
    );
  };


  // function percentage(totalDays, daysLeft) {
  //   const daysPassed = totalDays - daysLeft;
  //   const percentCompleted = (daysPassed / totalDays) * 100;
  //   let percentLeft = 100 - percentCompleted;
  //   percentLeft = Math.max(0, Math.min(100, percentLeft));
  //   return parseInt(percentLeft) || 0;
  // }

  // const textStyle = { fontSize: 18, fontWeight: 500 }

  const onCameraClick = (camera, status) => {
    console.log("camera", camera, status)
    let video_mode = status === "timelapse" ? false : true
    // let type = camera?.camera_type
    // if (status) {
    //   const basePath = type == "TIMELAPSE" ? "/timelapse/" : "/network/";

    //   // Navigate, passing the current camera and the list of cameras in the state
    //   navigate(basePath, {
    //     state: {
    //       camera: camera,
    //       cameras: cameras,
    //     },
    //   });
    //   return
    // }
    if (camera?.camera_name && status === "timelapse") {
      navigate("/camera-preview/", {
        state: {
          camera: camera,
          cameras: timelapseallState?.data?.results,
          video_mode: false,
        },
      });
    }
    else if (camera?.camera_name && status === "live") {
      const isPtzActive = Boolean(
        camera?.ptz === true ||
        camera?.ptz === 1 ||
        camera?.ptz === "true" ||
        camera?.has_ptz === true
      );
      if (isPtzActive) {
        navigate("/ptz-control/", {
          state: {
            camera: camera,
            cameras: livecamallState?.data?.results,
            video_mode: true,
          },
        });
      } else {
        navigate("/camera-preview/", {
          state: {
            camera: camera,
            cameras: livecamallState?.data?.results,
            video_mode: true,
          },
        });
      }
    }
  }

  const onTabClick = (type, status) => {
    if (type === 'timelapse') {
      dispatch({ type: `${TIMELAPSEALL}_GET`, payload: 0 });

    }
    if (type === 'live') {
      dispatch({ type: `${LIVECAMALL}_GET`, payload: 0 });
    }
    if (type === 'ai') {
      setCameras([])
    }
  }

  const onCardClick = (type) => {

    if (type === 'company') {
      navigate('/company/')
    }
    if (type === 'project') {
      navigate('/project/')
    }
    if (type === 'user') {
      navigate('/user-management/')
    }
    if (type === 'camera') {
      navigate('/timelapse-all/')
    }
  }

  const fetchProgress = (id = 0) => {
    const url = `worksites/0/?filter_by={"project_id":"${id}"}`
    dispatch({ type: `${WORKSITEALL}_GET`, payload: url });
  };
  let isSuperAdmin = user.main_role === "SuperAdmin"
  let userType = user.main_role === "User" ? 0 : 1
  return (
    <>
      <Container maxWidth="false" sx={{ pt: 3 }}>
        <Grid container spacing={'4vmin'}>
          <Grid item size={{ xs: 12, md: 6 }}>
            <Grid container spacing={'4vmin'}>
              <Grid item size={{ xs: 12, sm: isSuperAdmin ? 12 : 5 }}>

                <StatusCard height={80} space={2} userType={userType} isSuperAdmin={isSuperAdmin} datas={dashboardState?.data?.results || []} onCardClick={(type) => onCardClick(type)} />
              </Grid>

              {!isSuperAdmin && <Grid item size={{ xs: 12, sm: 7 }}>
                <Box className="rounded-lg shadow light-border" sx={{ height: "24.312vmin", minHeight: isSuperAdmin ? 244 : 278, overflow: "hidden" }}>
                  <WeatherCard location={locationName}
                    locationName={locationName?.country_name}
                    height={isSuperAdmin ? "253px" : "278px"}
                    py={1}
                    px={1}
                  />
                </Box>
              </Grid>}
            </Grid>
          </Grid>
          <Grid item size={{ xs: 12, md: 6 }}>
            <Box className='rounded-lg shadow' sx={{ height: "20.312vmin", minHeight: isSuperAdmin ? 244 : 278, overflow: "hidden" }}>
              {/* <Map height="100vmin" markers={loc} /> */}
              <VectorMap markers={loc} height={isSuperAdmin ? "230px" : "278px"} />
            </Box>
          </Grid>
        </Grid>


        {/* Title */}
        <Grid container spacing={2} sx={{ mt: 3, mb: 2 }}>
          <Grid item size={{ xs: 12, md: 6 }} order={isSuperAdmin ? 2 : 1}>
            <Typography className="dark-gray1 title-text" sx={{ fontWeight: 500, fontSize: 20 }}>Cameras</Typography>
          </Grid>
          <Grid item size={{ xs: 12, md: 6 }} order={isSuperAdmin ? 1 : 2}>
            <Typography className="dark-gray1 title-text" sx={{ fontWeight: 500, fontSize: 20 }}>Projects In Progress</Typography>
          </Grid>
        </Grid>
        {/* Bootom Cards */}
        <Grid container spacing={'4vmin'} mb={2} sx={{ pb: 4 }}>
          <Grid item size={{ xs: 12, md: 6 }} order={isSuperAdmin ? 2 : 1}>
            <CameraCard onTabClick={onTabClick} cameras={cameras} onCameraClick={(camera, status) => onCameraClick(camera, status)} />
            <div style={{ marginTop: 30 }}></div>
            <ProjectsChart projects={projectState?.data?.results || []}
              onChange={(e) => fetchProgress(e.target.value)}
              progress={worksiteallState?.data?.results || []} />
          </Grid>
          <Grid item size={{ xs: 12, md: 6 }} order={isSuperAdmin ? 1 : 2}>
            <InfoListCard isSuperAdmin={true} onClick={(data) => navigate(`/project/`, { state: { project: data } })} datas={projectState?.data?.results || []} calc={(d) => getDays(d.start_project_date, d.duration)} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}